import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/ProductsModule/ProductsModule.tsx");
